import { SftpInfo } from '@core/services/sftp/sftp-info.model';
import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';

export enum SftpInfoActionTypes {
  LOAD_SFTPINFOS = "[SftpInfo] Load SftpInfos",
  LOAD_SFTPINFOS_SUCCESS = "[SftpInfo] Load SftpInfos Success",
  LOAD_SFTPINFOS_FAIL = "[SftpInfo] Load SftpInfos Fail",
  LOAD_SFTPINFO = "[SftpInfo] Load SftpInfo",
  LOAD_SFTPINFO_SUCCESS = "[SftpInfo] Load SftpInfo Success",
  LOAD_SFTPINFO_FAIL = "[SftpInfo] Load SftpInfo Fail",
  CREATE_SFTPINFO = "[SftpInfo] Create SftpInfo",
  CREATE_SFTPINFO_SUCCESS = "[SftpInfo] Create SftpInfo Success",
  CREATE_SFTPINFO_FAIL = "[SftpInfo] Create SftpInfo Fail",
  UPDATE_SFTPINFO = "[SftpInfo] Update SftpInfo",
  UPDATE_SFTPINFO_SUCCESS = "[SftpInfo] Update SftpInfo Success",
  UPDATE_SFTPINFO_FAIL = "[SftpInfo] Update SftpInfo Fail",
  UPDATE_SFTPINFO_TOBE_INACTIVE = "[SftpInfo] Update SftpInfo to be Inactive",
  UPDATE_SFTPINFO_TOBE_INACTIVE_SUCCESS = "[SftpInfo] Update SftpInfo to be Inactive Success",
  UPDATE_SFTPINFO_TOBE_INACTIVE_FAIL = "[SftpInfo] Update SftpInfo to be Inactive Fail",
  DELETE_SFTPINFO = "[SftpInfo] Delete SftpInfo",
  DELETE_SFTPINFO_SUCCESS = "[SftpInfo] Delete SftpInfo Success",
  DELETE_SFTPINFO_FAIL = "[SftpInfo] Delete SftpInfo Fail",
}

export class LOADSFTPINFOS implements Action {
  readonly type = SftpInfoActionTypes.LOAD_SFTPINFOS;
}

export class LOADSFTPINFOSSUCCESS implements Action {
  readonly type = SftpInfoActionTypes.LOAD_SFTPINFOS_SUCCESS;
  constructor(public payload: SftpInfo[]) { }
}

export class LOADSFTPINFOSFAIL implements Action {
  readonly type = SftpInfoActionTypes.LOAD_SFTPINFOS_FAIL;
  constructor(public payload: string) { }
}

export class CREATESFTP implements Action {
  readonly type = SftpInfoActionTypes.CREATE_SFTPINFO;

  constructor(public payload: SftpInfo) { }
}

export class CREATESFTPSUCCESS implements Action {
  readonly type = SftpInfoActionTypes.CREATE_SFTPINFO_SUCCESS;

  constructor(public payload: SftpInfo) { }
}

export class CREATESFTPFAIL implements Action {
  readonly type = SftpInfoActionTypes.CREATE_SFTPINFO_FAIL;

  constructor(public payload: string) { }
}

export class UPDATESFTP implements Action {
  readonly type = SftpInfoActionTypes.UPDATE_SFTPINFO;

  constructor(public payload: SftpInfo) { }
}

export class UPDATESFTPSUCCESS implements Action {
  readonly type = SftpInfoActionTypes.UPDATE_SFTPINFO_SUCCESS;

  constructor(public payload: Update<SftpInfo>) { }
}

export class UPDATESFTPFAIL implements Action {
  readonly type = SftpInfoActionTypes.UPDATE_SFTPINFO_FAIL;

  constructor(public payload: string) { }
}

export type SftpInfoAction =
  | LOADSFTPINFOS
  | LOADSFTPINFOSSUCCESS
  | LOADSFTPINFOSFAIL
  | CREATESFTP
  | CREATESFTPSUCCESS
  | CREATESFTPFAIL
  | UPDATESFTP
  | UPDATESFTPSUCCESS
  | UPDATESFTPFAIL
